import { FC } from 'react';
import styles from '../../css/Alert.module.scss';

interface Props {
	title: string;
	body: string;
	type: 'default' | 'error';
}

const Alert: FC<Props> = ({ title, body, type }) => {
	return (
		<div className={styles.Alert}>
			<div className={styles.container}>
				{type === 'error' ? (
					<i className="fas fa-exclamation-circle" />
				) : (
					<i className="fas fa-info-circle" />
				)}
				<div>
					<h3>{title}</h3>
					<h4>{body}</h4>
				</div>
				<i className="fas fa-times-circle"></i>
			</div>
		</div>
	);
};

export default Alert;

export type { Props };
